var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#251163"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8195 10.2826L13.8926 13.7157C13.6539 13.8542 13.3537 13.8542 13.1074 13.7157L7.18046 10.2826C6.7571 10.0363 6.64934 9.45901 6.97263 9.09724C7.19585 8.84322 7.44987 8.63539 7.71927 8.48914L11.8912 6.17993C12.7841 5.67961 14.2312 5.67961 15.1241 6.17993L19.2961 8.48914C19.5655 8.63539 19.8195 8.85092 20.0428 9.09724C20.3507 9.45901 20.2429 10.0363 19.8195 10.2826Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0613 15.1473V20.3969C13.0613 20.9819 12.4686 21.3668 11.9452 21.1128C10.3595 20.3354 7.68855 18.8806 7.68855 18.8806C6.74947 18.3494 5.97974 17.0101 5.97974 15.9094V11.9375C5.97974 11.3294 6.61862 10.9446 7.14204 11.2448L12.6764 14.4546C12.9074 14.6008 13.0613 14.8625 13.0613 15.1473Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9387 15.1473V20.3969C13.9387 20.9819 14.5314 21.3668 15.0548 21.1128C16.6405 20.3354 19.3115 18.8806 19.3115 18.8806C20.2506 18.3494 21.0203 17.0101 21.0203 15.9094V11.9375C21.0203 11.3294 20.3814 10.9446 19.858 11.2448L14.3236 14.4546C14.0927 14.6008 13.9387 14.8625 13.9387 15.1473Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.eec40ce16319b04c90eba58eaa1567e3.svg";
export { ForwardRef as ReactComponent };